import React, { Component } from 'react'
import io from 'socket.io-client'

import { IconButton, Badge, Input, Button } from '@material-ui/core'
import VideocamIcon from '@material-ui/icons/Videocam'
import VideocamOffIcon from '@material-ui/icons/VideocamOff'
import MicIcon from '@material-ui/icons/Mic'
import MicOffIcon from '@material-ui/icons/MicOff'
import ScreenShareIcon from '@material-ui/icons/ScreenShare'
import StopScreenShareIcon from '@material-ui/icons/StopScreenShare'
import CallEndIcon from '@material-ui/icons/CallEnd'
import ChatIcon from '@material-ui/icons/Chat'
import WallpaperIcon from '@material-ui/icons/Wallpaper'

import Modal from 'react-bootstrap/Modal'
import 'bootstrap/dist/css/bootstrap.css'
import './Video.css'

const server_url = process.env.NODE_ENV === 'production'
	? window.location.origin
	: `${window.location.protocol}//${window.location.hostname}:4001`

var connections = {}
let peerConnectionConfig = {
	iceServers: [
		{ urls: 'stun:stun.l.google.com:19302' },
		{ urls: 'stun:stun.cloudflare.com:3478' },
	]
}
var socket = null
var socketId = null
var pendingCandidates = {}

const readAccessToken = () => {
	const params = new URLSearchParams(window.location.hash.replace(/^#/, ''))
	return params.get('token') || ''
}

class Video extends Component {
	constructor(props) {
		super(props)

		this.localVideoref = React.createRef()
		this.backgroundCanvasRef = React.createRef()
		const params = props.match.params
		this.roomId = params.roomId || ''
		this.role = 'patient'
		this.accessToken = readAccessToken()
		this.videoAvailable = false
		this.audioAvailable = false
		this.joinRequested = false
		this.transcriptionUploadInFlight = false
		this.pendingTranscriptionBlob = null
		this.transcriptionAbortController = null
		this.embeddedBrowser = /WhatsApp|FBAN|FBAV|Instagram|Line\/|; wv\)/i.test(navigator.userAgent)

		this.state = {
			video: false,
			audio: false,
			screen: false,
			showModal: false,
			showBackgrounds: false,
			screenAvailable: false,
			messages: [],
			message: '',
			newmessages: 0,
			stage: 'lobby',
			username: '',
			authStatus: 'checking',
			authError: '',
			deviceStatus: 'Revisando camara y microfono...',
			doctorPresent: false,
			waitingPatients: 0,
			turnConfigured: false,
			networkStatus: 'Preparando conexion de videollamada...',
			connectionStatus: 'Conectando...',
			permissionState: 'checking',
			remoteConnected: false,
			backgroundChoice: 'none',
			backgroundStatus: 'Camara normal',
			backgroundPreviewActive: false,
			transcriptionSegments: [],
			transcriptionInterim: '',
			transcriptionStatus: 'La transcripcion comenzara cuando se conecte la llamada.',
			presenceStatus: '',
		}

		connections = {}
		pendingCandidates = {}
	}

	componentDidMount() {
		document.addEventListener('visibilitychange', this.handleVisibilityChange)
		window.addEventListener('pagehide', this.handlePageHide)
		this.bootstrapSession()
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.stage !== this.state.stage && window.localStream) {
			this.attachLocalStream(window.localStream)
		}
	}

	notifyNativeHost = (type, data = {}) => {
		if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
			window.ReactNativeWebView.postMessage(JSON.stringify({ type, ...data }))
		}
	}

	updatePresence = async () => {
		try {
			const response = await fetch(`${server_url}/api/room-state`, { headers: { Authorization: `Bearer ${this.accessToken}` } })
			if (!response.ok) return
			const roomState = await response.json()
			const patientWaiting = Boolean(roomState.patientPresent) || Number((roomState.waitingPatients || []).length) > 0
			const otherParticipantReady = this.role === 'patient' ? Boolean(roomState.doctorPresent) : patientWaiting
			const presenceStatus = otherParticipantReady
				? (this.role === 'patient' ? 'Doctor en llamada - puedes ingresar' : 'Paciente esperando - puedes ingresar')
				: (this.role === 'patient' ? 'Esperando al doctor' : 'Esperando al paciente')
			this.setState({ doctorPresent: Boolean(roomState.doctorPresent), waitingPatients: Number((roomState.waitingPatients || []).length), presenceStatus })
			this.notifyNativeHost('presence', { status: otherParticipantReady ? (this.role === 'patient' ? 'Doctor en llamada' : 'Paciente esperando') : 'Sala de espera' })
		} catch (error) {}
	}

	startPresencePolling = () => {
		this.updatePresence()
		if (!this.presenceTimer) this.presenceTimer = setInterval(this.updatePresence, 3000)
	}

	startLiveTranscription = () => {
		if (this.audioRecorder || this.transcriptionUnavailable || !this.state.audio || !window.localStream) return
		if (!window.MediaRecorder) {
			this.setState({ transcriptionStatus: 'Este navegador no permite capturar fragmentos de audio.' })
			return
		}
		const audioTracks = window.localStream.getAudioTracks()
		if (!audioTracks.length) return
		const candidates = ['audio/webm;codecs=opus', 'audio/mp4', 'audio/webm', 'audio/ogg;codecs=opus']
		const mimeType = candidates.find((type) => !MediaRecorder.isTypeSupported || MediaRecorder.isTypeSupported(type)) || ''
		try {
			const recorder = new MediaRecorder(new MediaStream(audioTracks), mimeType ? { mimeType } : undefined)
			const chunks = []
			recorder.ondataavailable = (event) => { if (event.data && event.data.size) chunks.push(event.data) }
			recorder.onstop = () => {
				this.audioRecorder = null
				const shouldContinue = !this.transcriptionStopping && this.state.stage === 'call' && this.state.remoteConnected && this.state.audio
				if (shouldContinue) setTimeout(this.startLiveTranscription, 100)
				if (chunks.length && !this.transcriptionStopping) this.queueTranscriptionChunk(new Blob(chunks, { type: recorder.mimeType || mimeType || 'audio/webm' }))
			}
			this.audioRecorder = recorder
			if (!this.transcriptionUploadInFlight) this.setState({ transcriptionStatus: 'Transcripcion activa - escuchando...' })
			recorder.start()
			this.transcriptionTimer = setTimeout(() => { if (recorder.state === 'recording') recorder.stop() }, 7000)
		} catch (error) {
			this.transcriptionUnavailable = true
			this.setState({ transcriptionStatus: 'No fue posible iniciar la captura segura de audio.' })
		}
	}

	queueTranscriptionChunk = (blob) => {
		this.pendingTranscriptionBlob = blob
		if (!this.transcriptionUploadInFlight) this.processNextTranscriptionChunk()
	}

	processNextTranscriptionChunk = async () => {
		const blob = this.pendingTranscriptionBlob
		if (!blob || this.transcriptionStopping) return
		this.pendingTranscriptionBlob = null
		this.transcriptionUploadInFlight = true
		const uploadResult = await this.uploadTranscriptionChunk(blob)
		this.transcriptionUploadInFlight = false

		if (this.pendingTranscriptionBlob && !this.transcriptionStopping) {
			this.processNextTranscriptionChunk()
		} else if (!this.transcriptionStopping && uploadResult === 'success') {
			this.setState({ transcriptionStatus: 'Transcripcion activa - escuchando...' })
		}
	}

	uploadTranscriptionChunk = async (blob) => {
		const controller = new AbortController()
		this.transcriptionAbortController = controller
		const timeout = setTimeout(() => controller.abort(), 60000)
		try {
			this.setState({ transcriptionStatus: 'Procesando transcripcion...' })
			const response = await fetch(`${server_url}/api/transcriptions/chunk`, { method: 'POST', headers: { Authorization: `Bearer ${this.accessToken}`, 'Content-Type': blob.type || 'audio/webm' }, body: blob, signal: controller.signal })
			const payload = await response.json()
			if (!response.ok) throw new Error(payload.detail || payload.error || 'Servicio no disponible')
			const text = String(payload.text || '').trim()
			if (!text) {
				this.setState({ transcriptionStatus: 'No se detecto voz en el ultimo fragmento. Continuamos escuchando...' })
				return 'empty'
			}
			if (socket) socket.emit('transcription-segment', text)
			return 'success'
		} catch (error) {
			if (!this.transcriptionStopping) this.setState({ transcriptionStatus: error.name === 'AbortError' ? 'La transcripcion tardo demasiado; continuamos escuchando.' : `Transcripcion temporalmente no disponible: ${error.message}` })
			return 'error'
		} finally {
			clearTimeout(timeout)
			if (this.transcriptionAbortController === controller) this.transcriptionAbortController = null
		}
	}

	stopLiveTranscription = () => {
		this.transcriptionStopping = true
		this.pendingTranscriptionBlob = null
		if (this.transcriptionAbortController) this.transcriptionAbortController.abort()
		this.transcriptionAbortController = null
		if (this.transcriptionTimer) clearTimeout(this.transcriptionTimer)
		const recorder = this.audioRecorder
		this.audioRecorder = null
		if (recorder && recorder.state === 'recording') try { recorder.stop() } catch (error) {}
		setTimeout(() => { this.transcriptionStopping = false }, 200)
	}

	bootstrapSession = async () => {
		if (!this.accessToken) {
			this.setState({ authStatus: 'denied', authError: 'Este enlace no contiene una credencial de acceso válida.' })
			return
		}
		try {
			const response = await fetch(`${server_url}/api/session`, { headers: { Authorization: `Bearer ${this.accessToken}` } })
			const payload = await response.json()
			if (!response.ok || !payload.session) throw new Error(payload.message || 'No autorizado')
			const session = payload.session
			if (String(session.roomId) !== String(this.roomId)) throw new Error('La credencial no corresponde a esta sala.')
			this.role = session.role
			this.roomId = session.roomId
			this.session = session
			this.setState({ authStatus: 'ready', username: session.participantName }, () => {
				this.loadIceServers()
				this.getPermissions()
				this.startPresencePolling()
			})
		} catch (error) {
			this.setState({ authStatus: 'denied', authError: error.message || 'No se pudo validar el acceso.' })
		}
	}

	loadIceServers = () => {
		this.iceServersPromise = fetch(`${server_url}/api/ice-servers`, { headers: { Authorization: `Bearer ${this.accessToken}` } })
			.then((response) => response.json())
			.then((config) => {
				if (config.iceServers && config.iceServers.length) {
					peerConnectionConfig = { iceServers: config.iceServers }
				}
				this.setState({
					turnConfigured: Boolean(config.turnConfigured),
					networkStatus: config.turnConfigured
						? 'Conexion universal lista para Wi-Fi y datos moviles.'
						: 'Conexion directa disponible. Falta activar TURN para redes moviles.'
				})
			})
			.catch(() => this.setState({ networkStatus: 'No se pudo verificar el relay TURN.' }))

		return this.iceServersPromise
	}

	componentWillUnmount() {
		document.removeEventListener('visibilitychange', this.handleVisibilityChange)
		window.removeEventListener('pagehide', this.handlePageHide)
		if (this.presenceTimer) clearInterval(this.presenceTimer)
		this.stopLiveTranscription()
		this.stopVirtualBackground()
		if (this.selfieSegmenter) {
			this.selfieSegmenter.close().catch(() => {})
			this.selfieSegmenter = null
		}
		this.stopLocalTracks()
		if (socket) {
			socket.disconnect()
		}
	}

	getCameraConstraints = () => ({
		facingMode: 'user',
		width: { ideal: 1280 },
		height: { ideal: 720 },
		aspectRatio: { ideal: 16 / 9 },
		frameRate: { ideal: 24, max: 30 }
	})

	getAudioConstraints = () => ({
		echoCancellation: true,
		noiseSuppression: true,
		autoGainControl: true,
		channelCount: { ideal: 1 },
		sampleRate: { ideal: 16000 }
	})

	getCameraConstraintCandidates = () => [
		this.getCameraConstraints(),
		{
			facingMode: { ideal: 'user' },
			width: { ideal: 640 },
			height: { ideal: 480 }
		},
		{ facingMode: { ideal: 'user' } },
		true
	]

	requestMediaStream = async ({ video, audio }) => {
		const videoCandidates = video
			? this.getCameraConstraintCandidates()
			: [false]
		const audioCandidates = audio
			? [this.getAudioConstraints(), true]
			: [false]
		let lastError = null

		for (const videoConstraints of videoCandidates) {
			for (const audioConstraints of audioCandidates) {
				try {
					return await navigator.mediaDevices.getUserMedia({
						video: videoConstraints,
						audio: audioConstraints
					})
				} catch (error) {
					lastError = error
				}
			}
		}

		throw lastError || new Error('No se pudo acceder a los dispositivos multimedia.')
	}

	getPermissions = async () => {
		this.setState({ permissionState: 'checking', deviceStatus: 'Solicitando acceso a camara y microfono...' })
		if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
			const localNetwork = !window.isSecureContext && window.location.hostname !== 'localhost'
			const deviceStatus = localNetwork
				? 'El navegador bloqueo los dispositivos porque este enlace local no usa HTTPS. Abre un enlace HTTPS para probar desde el telefono.'
				: 'Este navegador interno no permite revisar camara y microfono. Abre el enlace directamente en Safari o Chrome.'
			this.setState({ permissionState: 'blocked', deviceStatus })
			this.notifyNativeHost('media-permission', { granted: false, camera: false, microphone: false, status: deviceStatus })
			return
		}

		this.setState({
			screenAvailable: Boolean(navigator.mediaDevices.getDisplayMedia)
		})

		try {
			const stream = await this.requestMediaStream({ video: true, audio: true })
			this.videoAvailable = stream.getVideoTracks().length > 0
			this.audioAvailable = stream.getAudioTracks().length > 0
			this.setPreviewStream(stream)
			this.setState({
				video: this.videoAvailable,
				audio: this.audioAvailable,
				permissionState: 'granted',
				deviceStatus: 'Camara y microfono detectados.'
			})
			this.notifyNativeHost('media-permission', {
				granted: this.videoAvailable && this.audioAvailable,
				camera: this.videoAvailable,
				microphone: this.audioAvailable,
				status: 'Camara y microfono detectados.'
			})
		} catch (error) {
			this.permissionError = error && error.name
			await this.tryPartialPermissions()
		}
	}

	tryPartialPermissions = async () => {
		let stream = null

		try {
			stream = await this.requestMediaStream({ video: true, audio: false })
			this.videoAvailable = true
		} catch (error) {
			this.videoAvailable = false
		}

		try {
			const audioStream = await this.requestMediaStream({ video: false, audio: true })
			this.audioAvailable = true

			if (stream) {
				audioStream.getAudioTracks().forEach((track) => stream.addTrack(track))
			} else {
				stream = audioStream
			}
		} catch (error) {
			this.audioAvailable = false
		}

		if (stream) {
			this.setPreviewStream(stream)
		}

		const deviceStatus = this.getDeviceStatusText()
		this.setState({
			video: this.videoAvailable,
			audio: this.audioAvailable,
			permissionState: stream ? 'granted' : 'blocked',
			deviceStatus
		})
		this.notifyNativeHost('media-permission', {
			granted: this.videoAvailable && this.audioAvailable,
			camera: this.videoAvailable,
			microphone: this.audioAvailable,
			status: deviceStatus
		})
	}

	getDeviceStatusText = () => {
		if (this.videoAvailable && this.audioAvailable) {
			return 'Camara y microfono detectados.'
		}

		if (this.videoAvailable) {
			return 'Camara detectada. No se detecto microfono.'
		}

		if (this.audioAvailable) {
			return 'Microfono detectado. No se detecto camara.'
		}

		if (!window.isSecureContext && window.location.hostname !== 'localhost') {
			return 'Camara y microfono bloqueados: en telefono debes abrir la sala mediante HTTPS.'
		}

		if (this.permissionError === 'NotAllowedError') {
			return 'Permiso denegado. Habilita camara y microfono en los ajustes del navegador y vuelve a intentar.'
		}

		return 'No se detecto camara ni microfono. Puedes entrar, pero tu video aparecera desactivado.'
	}

	setPreviewStream = (stream) => {
		this.stopLocalTracks()
		this.rawLocalStream = stream
		const hasLiveVideo = stream.getVideoTracks().some((track) => track.readyState === 'live')

		if (!hasLiveVideo) {
			// Replace the previous camera sender with a real black track. Without
			// this, WebRTC can keep showing the last virtual-background frame.
			const cameraOffTrack = this.black({ width: 640, height: 360 })
			const cameraOffStream = new MediaStream([cameraOffTrack, ...stream.getAudioTracks()])
			window.localStream = cameraOffStream
			this.attachLocalStream(cameraOffStream)
			this.setState({
				backgroundPreviewActive: false,
				backgroundStatus: this.state.backgroundChoice === 'none' ? 'Camara normal' : 'Camara apagada. Enciendela para ver tu fondo.'
			})
			return
		}

		window.localStream = stream
		this.attachLocalStream(stream)

		if (this.role === 'doctor' && this.state.backgroundChoice !== 'none') {
			this.startVirtualBackground(this.state.backgroundChoice)
		}
	}

	attachLocalStream = (stream) => {
		const video = this.localVideoref.current
		if (!video || !stream) return
		if (video.srcObject !== stream) {
			video.srcObject = stream
		}
		video.play().catch(() => {})
	}

	stopLocalTracks = () => {
		try {
			this.stopVirtualBackground()
			const tracks = new Set([
				...(this.rawLocalStream ? this.rawLocalStream.getTracks() : []),
				...(window.localStream ? window.localStream.getTracks() : [])
			])
			tracks.forEach((track) => track.stop())
		} catch (e) {}
		this.rawLocalStream = null
		window.localStream = null
	}

	ensureLocalStream = () => {
		if (window.localStream) {
			return
		}

		const blackSilence = (...args) => new MediaStream([this.black(...args), this.silence()])
		window.localStream = blackSilence()

		this.attachLocalStream(window.localStream)
	}

	getUserMedia = () => {
		if ((this.state.video && this.videoAvailable) || (this.state.audio && this.audioAvailable)) {
			this.requestMediaStream({
				video: this.state.video && this.videoAvailable,
				audio: this.state.audio && this.audioAvailable
			})
				.then(this.getUserMediaSuccess)
				.catch(() => {
					this.ensureLocalStream()
					this.setState({ deviceStatus: this.getDeviceStatusText() })
				})
		} else {
			this.stopLocalTracks()
			window.localStream = null
			this.ensureLocalStream()
			this.setState({
				backgroundPreviewActive: false,
				backgroundStatus: this.state.backgroundChoice === 'none' ? 'Camara normal' : 'Camara apagada. Enciendela para ver tu fondo.'
			})
			Object.keys(connections).forEach((id) => {
				this.syncLocalTracks(connections[id]).then(() => this.createAndSendOffer(id))
			})
		}
	}

	getUserMediaSuccess = (stream) => {
		this.setPreviewStream(stream)

		Object.keys(connections).forEach((id) => {
			this.syncLocalTracks(connections[id]).then(() => this.createAndSendOffer(id))
		})

		stream.getTracks().forEach(track => track.onended = () => {
			this.setState({
				video: false,
				audio: false,
				deviceStatus: 'Camara o microfono detenido.'
			}, () => {
				this.ensureLocalStream()
			})
		})
	}

	getDislayMedia = () => {
		if (this.state.screen && navigator.mediaDevices.getDisplayMedia) {
			navigator.mediaDevices.getDisplayMedia({ video: true, audio: true })
				.then(this.getDislayMediaSuccess)
				.catch((e) => console.log(e))
		}
	}

	getDislayMediaSuccess = (stream) => {
		this.setPreviewStream(stream)

		Object.keys(connections).forEach((id) => {
			this.syncLocalTracks(connections[id]).then(() => this.createAndSendOffer(id))
		})

		stream.getTracks().forEach(track => track.onended = () => {
			this.setState({ screen: false }, () => this.getUserMedia())
		})
	}

	loadBackgroundImage = (choice) => new Promise((resolve, reject) => {
		const sources = {
			test: '/backgrounds/fondo-prueba.svg',
			medical: '/backgrounds/consultorio-medico.png',
			bright: '/backgrounds/consultorio-claro.png',
			modern: '/backgrounds/consultorio-moderno.png'
		}
		const image = new Image()
		image.onload = () => resolve(image)
		image.onerror = reject
		image.src = sources[choice] || sources.medical
	})

	drawCover = (context, source, width, height) => {
		const sourceWidth = source.videoWidth || source.naturalWidth || source.width
		const sourceHeight = source.videoHeight || source.naturalHeight || source.height
		if (!sourceWidth || !sourceHeight) return
		const scale = Math.max(width / sourceWidth, height / sourceHeight)
		const drawWidth = sourceWidth * scale
		const drawHeight = sourceHeight * scale
		context.drawImage(source, (width - drawWidth) / 2, (height - drawHeight) / 2, drawWidth, drawHeight)
	}

	drawContained = (context, source, width, height, visualScale = 1) => {
		const sourceWidth = source.videoWidth || source.naturalWidth || source.width
		const sourceHeight = source.videoHeight || source.naturalHeight || source.height
		if (!sourceWidth || !sourceHeight) return
		const scale = Math.min(width / sourceWidth, height / sourceHeight) * visualScale
		const drawWidth = sourceWidth * scale
		const drawHeight = sourceHeight * scale
		context.drawImage(source, (width - drawWidth) / 2, (height - drawHeight) / 2, drawWidth, drawHeight)
	}

	loadMobileSegmentation = () => {
		if (window.SelfieSegmentation) {
			return Promise.resolve(window.SelfieSegmentation)
		}
		if (this.selfieSegmentationLibraryPromise) {
			return this.selfieSegmentationLibraryPromise
		}

		this.selfieSegmentationLibraryPromise = new Promise((resolve, reject) => {
			const script = document.createElement('script')
			script.src = `${server_url}/mediapipe/selfie-segmentation/selfie_segmentation.js`
			script.async = true
			script.onload = () => window.SelfieSegmentation
				? resolve(window.SelfieSegmentation)
				: reject(new Error('SelfieSegmentation no esta disponible'))
			script.onerror = () => reject(new Error('No se pudo cargar SelfieSegmentation'))
			document.head.appendChild(script)
		})

		return this.selfieSegmentationLibraryPromise
	}

	stopVirtualBackground = () => {
		this.backgroundLoopToken = (this.backgroundLoopToken || 0) + 1
		if (this.backgroundAnimation) {
			cancelAnimationFrame(this.backgroundAnimation)
			this.backgroundAnimation = null
		}
		if (this.processedVideoTrack) {
			this.processedVideoTrack.stop()
			this.processedVideoTrack = null
		}
		if (this.backgroundSourceVideo) {
			this.backgroundSourceVideo.pause()
			this.backgroundSourceVideo.srcObject = null
			this.backgroundSourceVideo = null
		}
		this.backgroundFrameBusy = false
		this.backgroundOutputCanvas = null
	}

	restoreRawStream = () => {
		this.stopVirtualBackground()
		if (!this.rawLocalStream) return
		window.localStream = this.rawLocalStream
		this.attachLocalStream(this.rawLocalStream)
		if (this.state.backgroundPreviewActive) {
			this.setState({ backgroundPreviewActive: false })
		}
		Object.keys(connections).forEach((id) => {
			this.syncLocalTracks(connections[id]).then(() => this.createAndSendOffer(id))
		})
	}

	startVirtualBackground = async (choice) => {
		if (this.role !== 'doctor' || choice === 'none') {
			this.restoreRawStream()
			return
		}

		const rawStream = this.rawLocalStream
		if (!rawStream || !rawStream.getVideoTracks().length) {
			this.setState({ backgroundStatus: 'Activa la camara para usar un fondo.' })
			return
		}

		const canvasCaptureStream =
			HTMLCanvasElement.prototype.captureStream ||
			HTMLCanvasElement.prototype.webkitCaptureStream
		if (!canvasCaptureStream) {
			this.setState({ backgroundStatus: 'Este telefono no permite fondos virtuales. La camara normal sigue activa.' })
			return
		}

		this.stopVirtualBackground()
		const token = this.backgroundLoopToken
		this.backgroundFrameFailures = 0
		this.backgroundFirstFrameDone = false
		this.backgroundLastProcessAt = 0
		this.setState({ backgroundStatus: 'Preparando el fondo virtual...', backgroundPreviewActive: false })
		const mobileDevice = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
		const iosDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent)

		try {
			const backgroundImage = await this.loadBackgroundImage(choice)
			if (token !== this.backgroundLoopToken) return

			if (!this.selfieSegmenter) {
				const SelfieSegmentation = await this.loadMobileSegmentation()
				this.selfieSegmenter = new SelfieSegmentation({
					locateFile: (file) => `${server_url}/mediapipe/selfie-segmentation/${file}`
				})
				this.selfieSegmenter.setOptions({ modelSelection: mobileDevice ? 0 : 1, selfieMode: false })
				await this.selfieSegmenter.initialize()
			}
			if (token !== this.backgroundLoopToken) return

			const sourceVideo = document.createElement('video')
			sourceVideo.muted = true
			sourceVideo.autoplay = true
			sourceVideo.playsInline = true
			sourceVideo.setAttribute('playsinline', '')
			sourceVideo.setAttribute('webkit-playsinline', '')
			sourceVideo.srcObject = rawStream
			await sourceVideo.play()
			this.backgroundSourceVideo = sourceVideo

			const canvas = document.createElement('canvas')
			canvas.width = iosDevice ? 480 : (mobileDevice ? 640 : 960)
			canvas.height = iosDevice ? 270 : (mobileDevice ? 360 : 540)
			// The transparent person mask must remain transparent until the
			// replacement image is painted behind it.
			const context = canvas.getContext('2d', { alpha: true })
			context.imageSmoothingEnabled = true
			context.imageSmoothingQuality = 'high'
			this.backgroundOutputCanvas = canvas
			const outputFrameRate = iosDevice ? 10 : (mobileDevice ? 12 : 24)
			const canvasStream = canvasCaptureStream.call(canvas, outputFrameRate)
			const canvasTrack = canvasStream.getVideoTracks()[0]
			if (!canvasTrack) throw new Error('El navegador no creo la pista de fondo virtual')
			if ('contentHint' in canvasTrack) canvasTrack.contentHint = 'detail'
			this.processedVideoTrack = canvasTrack

			const processedStream = new MediaStream([canvasTrack, ...rawStream.getAudioTracks()])
			let processedStreamActivated = false
			const activateProcessedStream = () => {
				if (processedStreamActivated || token !== this.backgroundLoopToken) return
				processedStreamActivated = true
				window.localStream = processedStream
				this.attachLocalStream(processedStream)
				Object.keys(connections).forEach((id) => {
					this.syncLocalTracks(connections[id]).then(() => this.createAndSendOffer(id))
				})
			}

			const renderMask = (result) => {
				if (token !== this.backgroundLoopToken || !result || !result.segmentationMask || !result.image) {
					this.backgroundFrameBusy = false
					return
				}
				try {
					const personScale = mobileDevice ? 0.92 : 0.95
					context.save()
					context.clearRect(0, 0, canvas.width, canvas.height)
					context.globalCompositeOperation = 'source-over'
					if ('filter' in context) context.filter = iosDevice ? 'blur(0.8px)' : (mobileDevice ? 'blur(1.2px)' : 'blur(1.5px)')
					this.drawContained(context, result.segmentationMask, canvas.width, canvas.height, personScale)
					if ('filter' in context) context.filter = iosDevice ? 'brightness(1.12) contrast(1.03) saturate(1.03)' : 'none'
					context.globalCompositeOperation = 'source-in'
					this.drawContained(context, result.image, canvas.width, canvas.height, personScale)
					if ('filter' in context) context.filter = 'none'
					context.globalCompositeOperation = 'destination-over'
					this.drawCover(context, backgroundImage, canvas.width, canvas.height)
					context.restore()

					const previewCanvas = this.backgroundCanvasRef.current
					if (previewCanvas) {
						const previewContext = previewCanvas.getContext('2d')
						previewContext.clearRect(0, 0, previewCanvas.width, previewCanvas.height)
						previewContext.drawImage(canvas, 0, 0, previewCanvas.width, previewCanvas.height)
					}

					this.backgroundFrameFailures = 0
					if (!this.backgroundFirstFrameDone || !this.state.backgroundPreviewActive) {
						this.backgroundFirstFrameDone = true
						activateProcessedStream()
						this.setState({ backgroundStatus: 'Fondo virtual activo', backgroundPreviewActive: true })
					}
				} catch (error) {
					this.backgroundFrameFailures += 1
					console.log('No se pudo dibujar el fondo virtual movil', error)
					if (this.backgroundFrameFailures >= 8) {
						this.restoreRawStream()
						this.setState({ backgroundStatus: 'No se pudo procesar el fondo en este telefono. La camara normal sigue activa.', backgroundPreviewActive: false })
					}
				}
				this.backgroundFrameBusy = false
			}

			this.selfieSegmenter.onResults(renderMask)

			const processFrame = () => {
				if (token !== this.backgroundLoopToken) return
				if (sourceVideo.readyState < 2) {
					this.backgroundAnimation = requestAnimationFrame(processFrame)
					return
				}
				if (!this.state.video) {
					context.globalCompositeOperation = 'source-over'
					context.fillStyle = '#05080b'
					context.fillRect(0, 0, canvas.width, canvas.height)
					this.backgroundFrameBusy = false
					this.backgroundAnimation = requestAnimationFrame(processFrame)
					return
				}
				const frameTime = performance.now()
				const frameInterval = iosDevice ? 100 : (mobileDevice ? 80 : 42)
				if (!this.backgroundFrameBusy && frameTime - this.backgroundLastProcessAt >= frameInterval) {
					this.backgroundFrameBusy = true
					this.backgroundLastProcessAt = frameTime
					this.selfieSegmenter.send({ image: sourceVideo }).catch((error) => {
						this.backgroundFrameBusy = false
						this.backgroundFrameFailures += 1
						if (this.backgroundFrameFailures >= 8) {
							this.restoreRawStream()
							this.setState({ backgroundStatus: 'No se pudo procesar el fondo en este telefono. La camara normal sigue activa.' })
						}
						console.log('No se pudo procesar un cuadro del fondo movil', error)
					})
				}
				this.backgroundAnimation = requestAnimationFrame(processFrame)
			}

			processFrame()
		} catch (error) {
			console.log('No se pudo activar el fondo virtual', error)
			this.restoreRawStream()
			this.setState({ backgroundStatus: 'No se pudo cargar el fondo. La camara normal sigue activa.', backgroundPreviewActive: false })
		}
	}

	selectBackground = (choice) => {
		this.setState({
			backgroundChoice: choice,
			backgroundStatus: choice === 'none' ? 'Camara normal' : 'Preparando el fondo virtual...',
			backgroundPreviewActive: false
		}, () => {
			if (choice === 'none') {
				this.restoreRawStream()
			} else {
				this.startVirtualBackground(choice)
			}
		})
	}

	gotMessageFromServer = async (fromId, socketMessage) => {
		const signal = JSON.parse(socketMessage)

		if (fromId !== socketId) {
			if (!connections[fromId]) {
				this.createPeerConnection(fromId)
			}
			const peer = connections[fromId]

			if (signal.sdp) {
				try {
					await peer.setRemoteDescription(new RTCSessionDescription(signal.sdp))
					const queued = pendingCandidates[fromId] || []
					for (const candidate of queued) {
						await peer.addIceCandidate(candidate)
					}
					pendingCandidates[fromId] = []

					if (signal.sdp.type === 'offer') {
						await this.syncLocalTracks(peer)
						const description = await peer.createAnswer()
						await peer.setLocalDescription(description)
						socket.emit('signal', fromId, JSON.stringify({ sdp: peer.localDescription }))
					}
				} catch (error) {
					console.log('Error procesando SDP', error)
				}
			}

			if (signal.ice) {
				const candidate = new RTCIceCandidate(signal.ice)
				if (peer.remoteDescription) {
					peer.addIceCandidate(candidate).catch(e => console.log(e))
				} else {
					pendingCandidates[fromId] = pendingCandidates[fromId] || []
					pendingCandidates[fromId].push(candidate)
				}
			}
		}
	}

	syncLocalTracks = async (peer) => {
		this.ensureLocalStream()
		const senders = peer.getSenders ? peer.getSenders() : []

		for (const track of window.localStream.getTracks()) {
			const sender = senders.find((item) => item.track && item.track.kind === track.kind)
			if (sender) {
				await sender.replaceTrack(track)
			} else {
				peer.addTrack(track, window.localStream)
			}
		}
	}

	createAndSendOffer = async (id, iceRestart = false) => {
		const peer = connections[id]
		if (!peer || !socket) return

		try {
			const description = await peer.createOffer({ iceRestart })
			await peer.setLocalDescription(description)
			socket.emit('signal', id, JSON.stringify({ sdp: peer.localDescription }))
		} catch (error) {
			console.log('Error creando oferta', error)
		}
	}

	changeCssVideos = (main) => {
		if (!main) return
		const hasRemote = main.querySelector('.remote-video') !== null
		main.classList.toggle('has-remote', hasRemote)
	}

	createPeerConnection = (socketListId) => {
		if (socketListId === socketId) return null
		connections[socketListId] = new RTCPeerConnection(peerConnectionConfig)
		const peer = connections[socketListId]

		peer.onicecandidate = function (event) {
			if (event.candidate != null) {
				socket.emit('signal', socketListId, JSON.stringify({ ice: event.candidate }))
			}
		}

		peer.onconnectionstatechange = () => {
			const labels = {
				new: 'Preparando conexion...',
				connecting: 'Conectando audio y video...',
				connected: 'Llamada conectada',
				disconnected: 'Conexion interrumpida. Reconectando...',
				failed: 'No fue posible conectar las redes.',
				closed: 'Llamada finalizada'
			}
			this.setState({ connectionStatus: labels[peer.connectionState] || 'Conectando...' })
			if (peer.connectionState === 'connected') {
				this.notifyNativeHost('call-connected')
				this.startLiveTranscription()
			} else if (['disconnected', 'failed', 'closed'].includes(peer.connectionState)) {
				this.notifyNativeHost('call-waiting')
			}
			if (peer.connectionState === 'failed' && peer.restartIce) {
				peer.restartIce()
				this.createAndSendOffer(socketListId, true)
			}
		}

		const showRemoteStream = (stream) => {
			if (!stream) return
			this.setState({ remoteConnected: true, connectionStatus: 'Llamada conectada' })
			this.notifyNativeHost('call-connected')
			this.startLiveTranscription()
			const existingVideo = document.querySelector(`[data-socket="${socketListId}"]`)
			if (existingVideo !== null) {
				existingVideo.srcObject = stream
				existingVideo.play().catch(() => {})
				return
			}

			const main = document.getElementById('main')
			const video = document.createElement('video')

			video.className = 'remote-video'
			video.setAttribute('data-socket', socketListId)
			video.srcObject = stream
			video.autoplay = true
			video.playsInline = true
			this.configureAutomaticPictureInPicture(video)
			video.setAttribute('webkit-playsinline', 'true')

			main.appendChild(video)
			main.classList.add('has-remote')
			video.play().catch(() => {})
			this.changeCssVideos(main)
		}

		peer.ontrack = (event) => {
			showRemoteStream(event.streams && event.streams[0] ? event.streams[0] : new MediaStream([event.track]))
		}

		peer.onaddstream = (event) => showRemoteStream(event.stream)

		this.ensureLocalStream()
		this.syncLocalTracks(peer).catch(e => console.log(e))
		return peer
	}

	connectToSocketServer = () => {
		if (socket) {
			this.requestJoinCall()
			return
		}

		socket = io.connect(server_url, {
			secure: window.location.protocol === 'https:',
			query: { token: this.accessToken },
		})

		socket.on('signal', this.gotMessageFromServer)
		socket.on('chat-message', this.addMessage)
		socket.on('transcription-segment', (segment) => {
			if (!segment || !segment.text || !segment.speaker) return
			this.setState((state) => ({
				transcriptionSegments: [...state.transcriptionSegments, segment].slice(-30),
				transcriptionInterim: '',
				transcriptionStatus: 'Transcripcion activa.'
			}))
		})

		socket.on('connect', () => {
			socketId = socket.id
			this.requestJoinCall()
		})

		socket.on('connect_error', () => {
			this.setState({ authStatus: 'denied', authError: 'La sesión fue rechazada o expiró. Vuelve a ingresar desde DrNet.' })
		})
		socket.on('error', () => {
			this.setState({ authStatus: 'denied', authError: 'La sesión fue rechazada o expiró. Vuelve a ingresar desde DrNet.' })
		})

		socket.on('join-rejected', (error) => {
			this.joinRequested = false
			this.setState({ connectionStatus: error && error.message ? error.message : 'No fue posible entrar a la sala.' })
		})
		socket.on('session-expired', () => {
			this.stopLocalTracks()
			this.setState({ authStatus: 'denied', authError: 'La autorización de esta videollamada expiró. Vuelve a ingresar desde DrNet.' })
		})

		socket.on('room-state', (state) => {
			this.setState({
				doctorPresent: state.doctorPresent,
				waitingPatients: state.waitingPatients ? state.waitingPatients.length : 0
			})
		})

		socket.on('waiting-room', (state) => {
			this.joinRequested = false
			this.setState({
				stage: 'waiting',
				doctorPresent: state.doctorPresent,
				waitingPatients: state.waitingPatients ? state.waitingPatients.length : 0
			})
			this.notifyNativeHost('call-waiting')
		})

		socket.on('doctor-available', () => {
			this.requestJoinCall()
		})

		socket.on('doctor-left', () => {
			if (this.role === 'patient') {
				this.setState({ stage: 'waiting', doctorPresent: false })
			}
		})

		socket.on('user-left', (id) => {
			let video = document.querySelector(`[data-socket="${id}"]`)
			if (video !== null) {
				video.parentNode.removeChild(video)
				this.changeCssVideos(document.getElementById('main'))
			}

			delete connections[id]
			delete pendingCandidates[id]
			const remainingRemote = document.querySelector('.remote-video') !== null
			this.setState({
				remoteConnected: remainingRemote,
				connectionStatus: remainingRemote ? 'Llamada conectada' : (this.role === 'doctor' ? 'Esperando al paciente' : 'Esperando al doctor')
			})
			if (!remainingRemote) {
				this.notifyNativeHost('call-waiting')
				this.stopLiveTranscription()
			}
		})

		socket.on('user-joined', (id, clients) => {
			this.setState({
				stage: 'call',
				connectionStatus: this.role === 'doctor' ? 'Doctor en espera' : 'Paciente en espera'
			})
			this.ensureLocalStream()

			clients.filter((socketListId) => socketListId !== socketId).forEach((socketListId) => {
				if (!connections[socketListId]) {
					this.createPeerConnection(socketListId)
				}
			})

			if (id === socketId) {
				Object.keys(connections).forEach((id2) => {
					this.syncLocalTracks(connections[id2]).then(() => this.createAndSendOffer(id2))
				})
			}
		})
	}

	requestJoinCall = () => {
		if (!socket || this.joinRequested) {
			return
		}

		this.joinRequested = true
		socket.emit('join-call')
	}

	silence = () => {
		let ctx = new AudioContext()
		let oscillator = ctx.createOscillator()
		let dst = oscillator.connect(ctx.createMediaStreamDestination())
		oscillator.start()
		ctx.resume()
		return Object.assign(dst.stream.getAudioTracks()[0], { enabled: false })
	}

	black = ({ width = 640, height = 480 } = {}) => {
		let canvas = Object.assign(document.createElement('canvas'), { width, height })
		canvas.getContext('2d').fillRect(0, 0, width, height)
		let stream = canvas.captureStream()
		return Object.assign(stream.getVideoTracks()[0], { enabled: false })
	}

	handleVideo = () => {
		const nextVideoState = !this.state.video
		const videoTracks = this.rawLocalStream
			? this.rawLocalStream.getVideoTracks().filter((track) => track.readyState === 'live')
			: []

		if (!videoTracks.length) {
			this.setState({ video: nextVideoState }, () => this.getUserMedia())
			return
		}

		videoTracks.forEach((track) => { track.enabled = nextVideoState })
		if (!nextVideoState && this.backgroundOutputCanvas) {
			const context = this.backgroundOutputCanvas.getContext('2d')
			context.globalCompositeOperation = 'source-over'
			context.fillStyle = '#05080b'
			context.fillRect(0, 0, this.backgroundOutputCanvas.width, this.backgroundOutputCanvas.height)
		}

		this.setState({
			video: nextVideoState,
			backgroundPreviewActive: nextVideoState && this.state.backgroundChoice !== 'none' ? this.state.backgroundPreviewActive : false,
			backgroundStatus: this.state.backgroundChoice === 'none'
				? 'Camara normal'
				: (nextVideoState ? 'Preparando el fondo virtual...' : 'Camara apagada. Enciendela para ver tu fondo.')
		})
	}

	handleAudio = () => {
		const nextAudioState = !this.state.audio
		const audioTracks = this.rawLocalStream
			? this.rawLocalStream.getAudioTracks().filter((track) => track.readyState === 'live')
			: []

		if (!audioTracks.length && nextAudioState) {
			this.setState({ audio: true }, () => this.getUserMedia())
			return
		}

		audioTracks.forEach((track) => { track.enabled = nextAudioState })
		this.setState({ audio: nextAudioState }, () => {
			if (nextAudioState && this.state.remoteConnected) this.startLiveTranscription()
			else if (!nextAudioState) this.stopLiveTranscription()
		})
	}
	handleScreen = () => this.setState({ screen: !this.state.screen }, () => this.getDislayMedia())

	configureAutomaticPictureInPicture = (video) => {
		if (!video) return
		video.disablePictureInPicture = false
		try {
			video.autoPictureInPicture = true
			video.setAttribute('autopictureinpicture', '')
		} catch (error) {}
	}

	enterPictureInPicture = async () => {
		const video = document.querySelector('.remote-video') || this.localVideoref.current
		if (!video || document.pictureInPictureElement) return

		this.configureAutomaticPictureInPicture(video)

		try {
			if (video.requestPictureInPicture) {
				await video.requestPictureInPicture()
				this.notifyNativeHost('picture-in-picture-started')
				return
			}
			if (video.webkitSupportsPresentationMode && video.webkitSupportsPresentationMode('picture-in-picture')) {
				video.webkitSetPresentationMode('picture-in-picture')
				this.notifyNativeHost('picture-in-picture-started')
			}
		} catch (error) {}
	}

	handleVisibilityChange = () => {
		if (document.visibilityState === 'hidden' && this.state.remoteConnected) {
			this.enterPictureInPicture()
		}
	}

	handlePageHide = () => {
		if (this.state.remoteConnected) this.enterPictureInPicture()
	}

	handleEndCall = () => {
		if (!window.confirm('¿Estas seguro de finalizar la llamada?')) return
		this.stopLiveTranscription()
		this.stopLocalTracks()
		if (socket) socket.disconnect()
		this.notifyNativeHost('call-ended')
		this.setState({ stage: 'ended' })
	}

	openChat = () => this.setState({ showModal: true, newmessages: 0 })
	closeChat = () => this.setState({ showModal: false })
	openBackgrounds = () => this.setState({ showBackgrounds: true })
	closeBackgrounds = () => this.setState({ showBackgrounds: false })
	handleMessage = (e) => this.setState({ message: e.target.value })
	handleMessageKeyDown = (event) => {
		if (event.key === 'Enter' && !event.shiftKey) {
			event.preventDefault()
			this.sendMessage()
		}
	}

	addMessage = (data, sender, socketIdSender) => {
		this.setState(prevState => ({
			messages: [...prevState.messages, { sender, data, own: socketIdSender === socketId }],
		}))
		if (socketIdSender !== socketId) {
			this.setState({ newmessages: this.state.newmessages + 1 })
		}
	}

	sendMessage = () => {
		if (!this.state.message.trim()) {
			return
		}

		socket.emit('chat-message', this.state.message)
		this.setState({ message: '', sender: this.state.username })
	}

	connect = async () => {
		if (this.iceServersPromise) {
			await this.iceServersPromise
		}
		this.setState({
			stage: this.role === 'doctor' ? 'joining' : 'waiting'
		}, () => {
			this.ensureLocalStream()
			this.connectToSocketServer()
		})
	}

	renderBackgroundOptions() {
		const options = [
			{ id: 'none', label: 'Camara normal', helper: 'Sin fondo', image: null },
			{ id: 'test', label: 'Prueba azul', helper: 'Comprueba el efecto', image: '/backgrounds/fondo-prueba.svg' },
			{ id: 'medical', label: 'Consultorio medico', helper: 'Con material clinico', image: '/backgrounds/consultorio-medico.png' },
			{ id: 'bright', label: 'Consultorio claro', helper: 'Oficina tranquila', image: '/backgrounds/consultorio-claro.png' },
			{ id: 'modern', label: 'Consultorio moderno', helper: 'Calido y profesional', image: '/backgrounds/consultorio-moderno.png' },
		]

		return (
			<div className="background-picker">
				{options.map((option) => (
					<button
						type="button"
						key={option.id}
						className={`background-option ${this.state.backgroundChoice === option.id ? 'selected' : ''}`}
						onClick={() => this.selectBackground(option.id)}
						aria-pressed={this.state.backgroundChoice === option.id}
					>
						{option.image ? <img src={option.image} alt="" /> : <span className="no-background"><VideocamIcon /></span>}
						<span><strong>{option.label}</strong><small>{option.helper}</small></span>
					</button>
				))}
				<p className="background-status">{this.state.backgroundStatus}</p>
			</div>
		)
	}

	renderPreviewControls() {
		return (
			<div className="preview-controls" aria-label="Controles de vista previa">
				<button type="button" className={!this.state.video ? 'preview-control control-disabled' : 'preview-control'} onClick={this.handleVideo} aria-label={this.state.video ? 'Apagar camara' : 'Encender camara'}>
					{this.state.video ? <VideocamIcon /> : <VideocamOffIcon />}
					<span>Camara</span>
				</button>
				<button type="button" className={!this.state.audio ? 'preview-control control-disabled' : 'preview-control'} onClick={this.handleAudio} aria-label={this.state.audio ? 'Silenciar microfono' : 'Activar microfono'}>
					{this.state.audio ? <MicIcon /> : <MicOffIcon />}
					<span>Microfono</span>
				</button>
			</div>
		)
	}

	renderLobby() {
		return (
			<div className="consult-page">
				<section className="consult-shell">
					<div className="lobby-copy">
						<p className="eyebrow">{this.role === 'doctor' ? 'Acceso doctor' : 'Acceso paciente'}</p>
						<h1>Videoconsulta medica</h1>
						<p>{this.role === 'doctor' ? 'Revisa tu camara y pulsa el boton verde. Luego solo espera al paciente.' : 'Revisa tu camara y pulsa el boton verde. Nosotros te avisaremos cuando entre el doctor.'}</p>
						{this.state.presenceStatus ? <div className="presence-banner"><span className="live-dot"></span><strong>{this.state.presenceStatus}</strong></div> : null}
						{this.embeddedBrowser ? <div className="browser-warning"><strong>Abre este enlace fuera de WhatsApp</strong><span>Usa el menu y selecciona "Abrir en Safari" o "Abrir en Chrome".</span></div> : null}

					</div>

					<div className="preview-panel">
						<video ref={this.localVideoref} autoPlay muted playsInline className={`preview-video ${this.state.backgroundPreviewActive ? 'media-hidden' : ''}`}></video>
						<canvas ref={this.backgroundCanvasRef} width="640" height="360" className={`preview-video virtual-background-preview ${this.state.backgroundPreviewActive ? '' : 'media-hidden'}`}></canvas>
						<div className="preview-label"><span className="live-dot"></span>Vista previa privada</div>
						{this.renderPreviewControls()}
						<div className="lobby-form">
							<label>Nombre</label>
							<Input value={this.state.username} readOnly fullWidth />
							<Button variant="contained" color="primary" onClick={this.connect}>
								{this.role === 'doctor' ? 'Entrar como doctor' : 'Estoy listo para entrar'}
							</Button>
						</div>

						{this.role === 'doctor' ? <div className="lobby-backgrounds"><h3>Elige el fondo del doctor</h3><p>El paciente vera el consultorio detras de ti.</p>{this.renderBackgroundOptions()}</div> : null}

					</div>
				</section>
			</div>
		)
	}

	renderWaiting() {
		return (
			<div className="consult-page">
				<section className="waiting-shell">
					<div className="waiting-copy">
						<div className="waiting-icon"><span className="live-dot"></span></div>
						<p className="eyebrow">Sala de espera</p>
						<h1>Ya estas listo</h1>
						<p>Espera aqui. Cuando el doctor llegue, entraras automaticamente.</p>
						<div className="waiting-tip"><strong>No cierres esta pantalla</strong><span>Puedes dejar el telefono apoyado. Nosotros hacemos el resto.</span></div>
					</div>
					<div className="waiting-preview"><video ref={this.localVideoref} autoPlay muted playsInline className="preview-video waiting-video"></video>{this.renderPreviewControls()}<span>Solo tu puedes ver esta vista previa</span></div>
					<Button variant="contained" color="secondary" onClick={this.handleEndCall}>Salir</Button>
				</section>
			</div>
		)
	}

	renderCall() {
		const waitingTitle = this.role === 'doctor' ? 'Esperando al paciente' : 'Esperando al doctor'
		const waitingText = this.role === 'doctor'
			? 'Deja esta pantalla abierta. La llamada comenzara sola cuando entre el paciente.'
			: 'Deja esta pantalla abierta. La llamada comenzara sola cuando entre el doctor.'

		return (
			<div className={`call-page role-${this.role}`}>
				<header className="call-header">
					<div className="call-identity">
						<div><strong>Videoconsulta medica</strong></div>
					</div>
					<div className="connection-state"><span className="live-dot"></span>{this.state.connectionStatus}</div>
				</header>

				<div className="call-stage-shell">
					<div id="main" className="video-grid">
						{!this.state.remoteConnected ? <div className="call-waiting-card"><span className="waiting-pulse"></span><strong>{waitingTitle}</strong><p>{waitingText}</p><small>Todo listo</small></div> : null}
						<video id="my-video" ref={this.localVideoref} autoPlay muted playsInline disablePictureInPicture={false} className={`local-video ${this.state.backgroundPreviewActive ? 'media-hidden' : ''}`}></video>
						<canvas ref={this.backgroundCanvasRef} width="640" height="360" className={`local-video virtual-background-preview ${this.state.backgroundPreviewActive ? '' : 'media-hidden'}`}></canvas>
					</div>
				</div>

				<section className="live-transcription" aria-live="polite">
					<div className="transcription-heading">
						<div className="transcription-title">
							<strong>Transcripcion en tiempo real</strong>
							<span>{this.state.transcriptionStatus}</span>
						</div>
					</div>
					<div className="transcription-content">
						{this.state.transcriptionSegments.length ? this.state.transcriptionSegments.map((segment, index) => (
							<p key={`${segment.createdAt || index}-${index}`}>
								<strong>{segment.speaker} ({segment.role === 'doctor' ? 'Doctor' : 'Paciente'}):</strong> {segment.text}
							</p>
						)) : <p className="transcription-placeholder">Lo que hablen el paciente y el doctor aparecera aqui.</p>}
						{this.state.transcriptionInterim ? <p className="transcription-interim"><strong>{this.state.username}:</strong> {this.state.transcriptionInterim}</p> : null}
					</div>
				</section>

				<div className="btn-down">
					<div className="control-item"><IconButton aria-label={this.state.audio ? 'Silenciar microfono' : 'Activar microfono'} onClick={this.handleAudio} className={!this.state.audio ? 'control-off' : ''}>{this.state.audio === true ? <MicIcon /> : <MicOffIcon />}</IconButton><span>{this.state.audio ? 'Silenciar' : 'Activar audio'}</span></div>
					<div className="control-item"><IconButton aria-label={this.state.video ? 'Desactivar video' : 'Activar video'} onClick={this.handleVideo} className={!this.state.video ? 'control-off' : ''}>{this.state.video === true ? <VideocamIcon /> : <VideocamOffIcon />}</IconButton><span>{this.state.video ? 'Apagar video' : 'Activar video'}</span></div>
					<div className="control-item"><IconButton aria-label="Finalizar llamada" className="end-call" onClick={this.handleEndCall}><CallEndIcon /></IconButton><span>Finalizar</span></div>

					{this.role === 'doctor' ? <div className="control-item"><IconButton aria-label="Elegir fondo virtual" onClick={this.openBackgrounds} className={this.state.backgroundChoice !== 'none' ? 'control-active' : ''}><WallpaperIcon /></IconButton><span>Fondos</span></div> : null}

					{this.state.screenAvailable === true ?
						<div className="control-item screen-control"><IconButton aria-label="Compartir pantalla" onClick={this.handleScreen}>{this.state.screen === true ? <ScreenShareIcon /> : <StopScreenShareIcon />}</IconButton><span>Compartir</span></div>
						: null}

					<div className="control-item"><Badge badgeContent={this.state.newmessages} max={999} color="secondary"><IconButton aria-label="Abrir chat" onClick={this.openChat}><ChatIcon /></IconButton></Badge><span>Chat</span></div>
				</div>

				<Modal show={this.state.showModal} onHide={this.closeChat} centered dialogClassName="consult-chat-dialog" style={{ zIndex: '999999' }}>
					<Modal.Header closeButton className="chat-header">
						<Modal.Title><span className="chat-title-icon"><ChatIcon /></span><span>Mensajes de la consulta<small>Solo los participantes de esta sala</small></span></Modal.Title>
					</Modal.Header>
					<Modal.Body className="chat-body">
						{this.state.messages.length > 0 ? this.state.messages.map((item, index) => (
							<div key={index} className={`message-row ${item.own ? 'own-message' : ''}`}>
								<div className="message-avatar">{item.sender ? item.sender.charAt(0).toUpperCase() : '?'}</div>
								<div className="message-bubble"><strong>{item.own ? 'Tu' : item.sender}</strong><p>{item.data}</p></div>
							</div>
						)) : <div className="empty-chat"><ChatIcon /><strong>Aun no hay mensajes</strong><span>Escribe algo sencillo, por ejemplo: "Hola, ya estoy listo".</span></div>}
					</Modal.Body>
					<Modal.Footer className="div-send-msg">
						<Input placeholder="Escribe un mensaje..." value={this.state.message} onChange={this.handleMessage} onKeyDown={this.handleMessageKeyDown} fullWidth />
						<Button variant="contained" color="primary" onClick={this.sendMessage}>Enviar</Button>
					</Modal.Footer>
				</Modal>

				{this.role === 'doctor' ? <Modal show={this.state.showBackgrounds} onHide={this.closeBackgrounds} centered dialogClassName="background-dialog" style={{ zIndex: '999999' }}><Modal.Header closeButton><Modal.Title>Fondo virtual del doctor</Modal.Title></Modal.Header><Modal.Body><p className="background-help">Elige como quieres que el paciente vea el espacio detras de ti.</p>{this.renderBackgroundOptions()}</Modal.Body><Modal.Footer><Button variant="contained" color="primary" onClick={this.closeBackgrounds}>Listo</Button></Modal.Footer></Modal> : null}
			</div>
		)
	}

	render() {
		if (this.state.authStatus === 'checking') {
			return <div className="access-state"><div className="brand-mark">C</div><h1>Validando acceso seguro</h1><p>Espera un momento...</p></div>
		}

		if (this.state.authStatus === 'denied') {
			return <div className="access-state access-denied"><div className="brand-mark">C</div><h1>Acceso no autorizado</h1><p>{this.state.authError}</p><small>Abre nuevamente la videoconsulta desde DrNet.</small></div>
		}

		if (this.state.stage === 'ended') {
			return <div className="access-state"><div className="brand-mark">C</div><h1>Videoconsulta finalizada</h1><p>Ya puedes cerrar esta pantalla y regresar a DrNet.</p></div>
		}
		if (this.state.stage === 'call') {
			return this.renderCall()
		}

		if (this.state.stage === 'waiting' || this.state.stage === 'joining') {
			return this.role === 'patient' ? this.renderWaiting() : this.renderLobby()
		}

		return this.renderLobby()
	}
}

export default Video
